// extracted by mini-css-extract-plugin
export default {"tagHolder":"LiCustom_tagHolder__cqu+y","tag":"LiCustom_tag__PPR1m"};